import React,{Component} from "react";
import {observer} from 'mobx-react';
import localStyles from "../index.css";
import fonts from "../../../../../iconfonts.css";
import {Bubbles} from "../../SubComponents";
import {scenario} from "../../../../stores";

@observer
export default class ElementBlock extends Component{
    render(){
        const List = this.props.list;
        let BlockLine = List.find((item)=>{
            return item.status === 'clogged';

        });
        if(!BlockLine){
            BlockLine = List.find((item)=>{
                return (item.active && item.culture !== 'None' );
            });
            if(BlockLine){BlockLine = BlockLine.culture}
        }else{
            BlockLine = BlockLine.status
        }
        return(
            <div className={localStyles.hopperContainer}>
                <div className={localStyles.dcTitle}>{this.props.title}</div>
                <div className={localStyles.dcIcon}><i className={fonts[this.props.icon]} /></div>
                {List.map((item,i)=>{
                    return(
                        <div key ={i} onClick={()=>{if(item.type === 'hopper'){
                            scenario.openPathPopup(!!item.scenario.length ? item.scenario : item, !!item.scenario.length)
                        }}}>
                            <this.props.UIComponent item={item}/>
                        </div>
                    )
                })}
                <div className={localStyles.dcOutputBubbles}>
                    <Bubbles culture={BlockLine ? BlockLine : 'None'}/>
                    <div className={localStyles.dcOutputLine + ' ' + localStyles[BlockLine ? BlockLine : 'None']} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/ElevatorField/elementBlock/index.js